import { parseApiError } from "app/services/api.error.parser";
import { resetSessionStorage } from "app/services/session.service";
import { toast } from "app/services/toast.service";

const LOGIN_REDIRECT_URL = "/login?sessionExpired=true";

// Guards against parallel requests each triggering their own redirect when a session expires.
let isHandlingUnauthorized = false;

export const handleAxiosError = (error) => {
    if (!error) {
        console.error("Unknown error occurred");
        return null;
    }

    const parsed = parseApiError(error);

    if (parsed.isUnauthorized) {
        handleUnauthorizedAccessError(parsed.message);
        return parsed;
    }

    handleErrorWithToast(parsed.message);
    return parsed;
}

/**
 * Session has expired (HTTP 401). Clear the session and send the user to the login page, where a
 * "session expired" notice is shown. A full-page redirect guarantees a clean slate (in-memory
 * state, cached session reads and pending requests are all reset).
 */
export const handleUnauthorizedAccessError = (errMessage) => {
    console.error("Unauthorized:", errMessage);

    if (isHandlingUnauthorized) return;
    isHandlingUnauthorized = true;

    resetSessionStorage();
    window.location.assign(LOGIN_REDIRECT_URL);
}

export const handleErrorWithToast = (errMessage) => {
    console.error("Error:", errMessage);
    toast.error(errMessage);
}
